import { customConfig } from "config";

export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
};

export const createWrapperAndAppendToBody = (wrapperId) => {
  const wrapperElement = document.createElement("div");
  wrapperElement.setAttribute("id", wrapperId);
  document.body.appendChild(wrapperElement);

  return wrapperElement;
};

export const imagePath = (id, name, collectionName) => {
  if (name == "") return null;

  return `${customConfig.POCKETBASE_FILE_URL}/${collectionName}/${id}/${name}`;
};
